import { useSwr } from "hooks/atPort/useSwr";
import { formatQueryParams } from "utils/stringUtils";

export const useFindAllSystemNotifications = ({
  query,
}: {
  query: {
    pageSize?: number;
    after?: string;
    before?: string;
  };
}) => {
  const { data } = useSwr<AtPortSystemNotificationsResponse>(`/system-notification?${formatQueryParams(query)}`);

  return { data };
};
